import { graphql, useStaticQuery } from "gatsby";

export const getBestSellers = () => {
  const data = useStaticQuery(graphql`
    query {
      CategoryProducts: allWpSimpleProduct(
        filter: {
          productCategories: {
            nodes: { elemMatch: { id: { eq: "dGVybTo5NDc=" } } }
          }
        }
        limit: 10
      ) {
        category: nodes {
          id
          name
          databaseId
          slug
          description
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
              altText
            }
          }
          productTags {
            nodes {
              id
              name
            }
          }
          allPaActiveIngredient {
            nodes {
              name
              slug
              id
            }
          }
          isOnPromotion {
            isonpromotion
          }
          ... on WpSimpleProduct {
            price
            regularPrice
            stockStatus
            tierPrice {
              tierPrice {
                price
                price2
                price3
                price4
              }
            }
          }
        }
      }
    }
  `);

  return data.CategoryProducts.category;
};
